<template>
    <div class="operate-column-wrapper">
        <Icon width="21" height="18" :bgPosition="chatPosition" :hoverBgPosition="chatHoverPosition" @iconClick="clickHandle" />
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";

export default {
    name: "OperateColumn",
    props: ["data", "row"],
    components: {
        Icon
    },
    data() {
        return {
            chatPosition: "-334px -96px",
            chatHoverPosition: "-360px -96px"
        };
    },
    methods: {
        clickHandle() {
            let chatData = {
                userId: this.data.userId,
                answerDetail: this.data.answerDetail
            };
            this.$emit("click", chatData);
        }
    }
};
</script>

<style lang="less" scoped></style>
